module.exports = __webpack_public_path__ + "img/mustache.8c56d1ad.svg";